import React from "react";
import { injectIntl } from "react-intl";
import "./style.scss";
import CancelIcon from '@material-ui/icons/Cancel';

function WorkingHours({ intl: { messages }, show, close, schedules }) {
    const lang = localStorage.getItem("lang") || "en";
       
    return (
        <div className={`test-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="test-modal_container_content">
                    <CancelIcon onClick={close} className="test-modal_container_content_close" />
                <div className="test-modal_container_content_header">
                    <h4 className="working_hours_title">{messages.sampling.working_hours_title}</h4>
                    <p className="working_hours_subtitle">{messages.sampling.working_hours_subtitle}</p>
                </div>
                <div className="agency_working_hour_table">
                    <table>
                    { schedules?.map((schedule, index) => (
                            <tr key={index}>
                                <td>{schedule.day_name}</td>
                                <td>{schedule.is_working_day ? <span><span>{schedule.from_hour}</span>&nbsp;-&nbsp;<span>{schedule.to_hour}</span></span> : messages.sampling.holiday}</td>
                            </tr>
                    ))}
                    </table>
                </div>
                <div className="test-modal_container_content_body">
                    <div className="actions">
                        <button type="button" className="cancel" 
                            onClick={(e) => {
                                e.preventDefault();
                                close();
                                }}>
                                {messages.sampling.back_btn}                           
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default injectIntl(WorkingHours);